import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMenu } from '../../../../context/MenuContext';
import Error404 from '../../../pages/Error404';

/**
 * ProtectedRoute Component
 *
 * Wraps routes to check user permissions before rendering
 * If user doesn't have access, displays 404 (permission denied) page
 *
 * @param {React.ReactNode} children - Component to render if access is granted
 * @param {string} routePath - The route path to check permissions for (optional)
 */
const ProtectedRoute = ({ children, routePath }) => {
  const location = useLocation();
  const { getMenuList } = useMenu();

  // Get the path to check - use routePath prop or current pathname
  const pathToCheck = routePath || location.pathname;

  // Get all menu items
  const menuListFlat = getMenuList();

  // Search for matching menu item in MenuListFlat
  let hasAccess = false;
  let matchedPermissions = null;

  if (pathToCheck === '/dashboard') {
    return children;
  }

  for (const menu of menuListFlat) {
    if (menu.subMenus && menu.subMenus.length > 0) {
      for (const subMenu of menu.subMenus) {
        if (subMenu.routingKey === pathToCheck) {
          // Check if user has list permission for this route
          hasAccess = subMenu.hasListPermission === true;
          matchedPermissions = {
            hasListPermission: subMenu.hasListPermission,
            hasAddPermission: subMenu.hasAddPermission,
            hasEditPermission: subMenu.hasEditPermission,
            hasDeletePermission: subMenu.hasDeletePermission
          };
          break;
        }
      }
    }
    if (hasAccess || matchedPermissions) break;
  }

  // If user has no permission, show fancy 404 (permission denied) page
  if (!hasAccess) {
    return <Error404 isPermissionDenied={true} />;
  }

  // If user has access, render the component
  return children;
};

export default ProtectedRoute;
